// extracted by mini-css-extract-plugin
export default {"wrapper":"RoiIrrHint_wrapper__E8FE7","label":"RoiIrrHint_label__pDnyJ","tooltip":"RoiIrrHint_tooltip__zkBW2","card":"RoiIrrHint_card__+mlRf","item":"RoiIrrHint_item__Hml+K"};